import { render, staticRenderFns } from "./EditMealPlan.vue?vue&type=template&id=f2f0a99a"
import script from "./EditMealPlan.vue?vue&type=script&lang=js"
export * from "./EditMealPlan.vue?vue&type=script&lang=js"
import style0 from "./EditMealPlan.vue?vue&type=style&index=0&id=f2f0a99a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports